export enum SepoInteractionEnum {
  EXTENDED_WARRANTY = 'EXTENDED_WARRANTY',
  TUBE_SETTINGS = 'TUBE_SETTINGS',
  VISIT_E_SHOP_TILE = 'VISIT_E_SHOP_TILE',
  VISIT_E_SHOP_LINK = 'VISIT_E_SHOP_LINK',
  MARKETING_TILE_LINK = 'MARKETING_TILE_LINK',
  SERVICES_TILE = 'SERVICES_TILE',
  SERVICES_FORM = 'SERVICES_FORM',
}
